import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  NB_AUTH_OPTIONS,
  NbAuthSocialLink,
  NbAuthService,
  NbAuthResult,
} from '@nebular/auth';
import { getDeepFromObject } from '../../helpers';
import { NbThemeService, NbToastrService, NbGlobalPhysicalPosition } from '@nebular/theme';
import { EMAIL_PATTERN } from '../constants';
import { InitUserService } from '../../../@theme/services/init-user.service';
import { Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { UserStore } from '../../../@core/stores/user.store';
import { UsersService } from '../../../@core/backend/common/services/users.service';
import { ROLES } from '../../roles';
import { DEFAULTREDIRECT } from '../../defaultRedirectAfterLogin';


@Component({
  selector: 'app-ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class NgxLoginComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  minLength: number = this.getConfigValue('forms.validation.password.minLength');
  maxLength: number = this.getConfigValue('forms.validation.password.maxLength');
  redirectDelay: number = this.getConfigValue('forms.login.redirectDelay');
  showMessages: any = this.getConfigValue('forms.login.showMessages');
  strategy: string = this.getConfigValue('forms.login.strategy');
  socialLinks: NbAuthSocialLink[] = this.getConfigValue('forms.login.socialLinks');
  rememberMe = this.getConfigValue('forms.login.rememberMe');
  isEmailRequired: boolean = this.getConfigValue('forms.validation.email.required');
  isPasswordRequired: boolean = this.getConfigValue('forms.validation.password.required');

  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  submitted = false;
  loginForm: UntypedFormGroup;
  alive = true;
  showPassword = false;
  otpForm: UntypedFormGroup;
  isCodeFormVisible = false;
  otpError: string = '';
  otpSubmitted = false;
  resending = false;
  redirect = null;

  get email(): any { return this.loginForm.get('email'); }
  get password(): any { return this.loginForm.get('password'); }

  constructor(
    protected service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef,
    protected themeService: NbThemeService,
    private fb: UntypedFormBuilder,
    protected router: Router,
    private route: ActivatedRoute,
    protected initUserService: InitUserService,
    protected userStore: UserStore,
    protected userService: UsersService,
    private toastrService: NbToastrService
  ) { }

  ngOnInit(): void {
    const emailValidators = [
      Validators.pattern(EMAIL_PATTERN),
    ];
    if (this.isEmailRequired) {
      emailValidators.push(Validators.required);
    }

    const passwordValidators = [
      Validators.minLength(this.minLength),
      Validators.maxLength(this.maxLength),
    ];
    if (this.isPasswordRequired) {
      passwordValidators.push(Validators.required);
    }

    this.loginForm = this.fb.group({
      email: this.fb.control('', [...emailValidators]),
      password: this.fb.control('', [...passwordValidators]),
      rememberMe: this.fb.control(false),
    });

    this.otpForm = this.fb.group({
      code: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]]
    });
  }

  // login(): void {
  //   this.user = this.loginForm.value;
  //   this.errors = this.messages = [];
  //   this.submitted = true;
  //   this.service.authenticate(this.strategy, this.user).subscribe(
  //     (result: NbAuthResult) => {
  //       this.submitted = false;
  //       console.log("results", result);
  //       if (result.isSuccess()) {
  //         this.messages = result.getMessages();
  //         console.log("message", result.getMessages())
  //         this.initUser().pipe(take(1)).subscribe((user) => {
  //           let redirect = result.getRedirect();
  //           console.log("redirect", redirect);

  //           const urlRedirect = this.route.snapshot.queryParamMap.get('redirect');
  //           console.log("urlRedirect", urlRedirect);

  //           if (user.user.role === ROLES.ADMIN) {
  //             redirect = urlRedirect || DEFAULTREDIRECT.ADMIN;
  //           } else {
  //             redirect = urlRedirect || DEFAULTREDIRECT.CLIENT;
  //           }

  //           if (redirect) {
  //             setTimeout(() => {
  //               return this.router.navigateByUrl(redirect);
  //             }, this.redirectDelay);
  //           }

  //           this.cd.detectChanges();
  //         });
  //       } else {
  //         this.errors = result.getErrors();
  //         this.cd.detectChanges();
  //       }
  //     }
  //   );
  // }

  login(): void {
    this.user = this.loginForm.value;
    this.errors = this.messages = [];
    this.submitted = true;

    console.log("remember me= ", this.user.rememberMe);

    this.userService.login(this.user).subscribe(
      (result: any) => {
        this.submitted = false;

        if (result?.otp_required) {
          // Display OTP form
          this.isCodeFormVisible = true;
          this.messages = [(result as any).message];
          this.cd.detectChanges();
        } else {
            this.messages = result.messages;
            this.toastrService.show(
              result?.messages,
              '',
              {
                status: 'success',
                duration: 6000,
                position: NbGlobalPhysicalPosition.TOP_RIGHT
              }
            );
          this.setUser(result);
        }
      },
      err => {
        this.errors = ['Something went wrong'];
        console.log("error", err);
        const message = err.error?.errors;
        this.toastrService.show(
          message,
          '',
          {
            status: 'danger',
            duration: 5000,
            position: NbGlobalPhysicalPosition.TOP_RIGHT
          }
        );
        this.submitted = false;
        this.cd.detectChanges();
      }
    )
  }

  // loginWithCredentials(): void {
  //   this.user = this.loginForm.value;
  //   this.errors = this.messages = [];
  //   this.submitted = true;

  //   this.userService.login(this.user).subscribe(
  //     (result: any) => {
  //       this.submitted = false;
  //       // console.log("result", result);
  //       if (result?.otp_required) {
  //         // Display OTP form
  //         this.isCodeFormVisible = true;
  //         this.messages = [(result as any).message];
  //         this.cd.detectChanges();
  //       } else {
  //           this.cd.detectChanges();
  //           const message = result.messages;
  //           this.toastrService.show(
  //             message,
  //             '',
  //             {
  //               status: 'success',
  //               duration: 5000,
  //               position: NbGlobalPhysicalPosition.TOP_RIGHT
  //             }
  //           );
  //           this.setUser(result);
  //         }
  //     },
  //     err => {
  //       this.errors = ['Something went wrong'];
  //       console.log("error", err);
  //       const message = err.error?.errors;
  //       this.toastrService.show(
  //         message,
  //         '',
  //         {
  //           status: 'danger',
  //           duration: 5000,
  //           position: NbGlobalPhysicalPosition.TOP_RIGHT
  //         }
  //       );
  //       this.submitted = false;
  //       this.cd.detectChanges();
  //     }
  //   )
  // }

  verifyOtp(): void {
    this.otpError = '';
    this.otpSubmitted = true;

    if (this.otpForm.invalid) {
      this.otpSubmitted = false;
      return;
    }

    const payload = {
      email: this.loginForm.value.email,
      code: this.otpForm.value.code,
      password: this.loginForm.value.password,
      rememberMe: this.user.rememberMe
    };

    this.userService.verifyOtp(payload).subscribe(
      (res: any) => {
        this.messages = res.messages;
        this.setUser(res);
        this.isCodeFormVisible = false;
        this.otpSubmitted = false;
      },
      err => {
        const message = err.error?.error;
        this.toastrService.show(
          '',
          message,
          {
            status: 'danger',
            duration: 5000,
            position: NbGlobalPhysicalPosition.TOP_RIGHT
          }
        );
        // this.errors = [err.error.error];
        this.submitted = false;
      }
    );
  }

  setUser(res: any) {
    if (res?.token) {
      const token = res.token.access_token;
      localStorage.setItem('access_token', token);
      const tokenValue = {
        access_token: res.token.access_token,
        expires_in: res.token.expires_in
      };

      localStorage.setItem('auth_app_token', JSON.stringify({
        name: 'nb:auth:oauth2:jwt:token',
        ownerStrategyName: 'email',
        createdAt: Date.now(),
        value: JSON.stringify(tokenValue)
      }));
    }

    this.initUser().pipe(take(1)).subscribe((user) => {
      let redirect = this.redirect;
      const urlRedirect = this.route.snapshot.queryParamMap.get('redirect');
      if (user.user.role === ROLES.ADMIN) {
        redirect = urlRedirect || DEFAULTREDIRECT.ADMIN;
      } else {
        redirect = urlRedirect || DEFAULTREDIRECT.CLIENT;
      }

      if (redirect) {
        setTimeout(() => {
          return this.router.navigateByUrl(redirect);
        }, this.redirectDelay);
      }
      this.cd.detectChanges();
    });
  }

  resendOtp() {
    const payload = {
      email: this.loginForm.value.email,
      password: this.loginForm.value.password,
      rememberMe: this.user.rememberMe
    };

    this.resending = true;
    this.cd.detectChanges();
    this.userService.resendOtp(payload).subscribe(
      (res: any) => {
        console.log("verification response", res);
        this.messages = [(res as any).message];
        this.toastrService.show(
          res.message,
          '',
          {
            status: 'info',
            duration: 5000,
            position: NbGlobalPhysicalPosition.TOP_RIGHT
          }
        );
        this.cd.detectChanges();
        this.resending = false;
      },
      err => {
        this.errors = ['Something went wrong'];
        console.log("error", err);
        const message = err.error?.errors;
        this.toastrService.show(
          message,
          '',
          {
            status: 'danger',
            duration: 5000,
            position: NbGlobalPhysicalPosition.TOP_RIGHT
          }
        );
        this.submitted = false;
        this.resending = false;
        this.cd.detectChanges();
      }
    )
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }

  initUser(): Observable<any> {
    return this.initUserService.initCurrentUser();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public toggleShowPassword(): void {
    this.showPassword = !this.showPassword;
  }

  public getInputType(): string {
    if (this.showPassword) {
      return 'text';
    }
    return 'password';
  }
}